module.exports = __webpack_public_path__ + "static/home-mobile-screen1-ae81204a5c1d240ee7621175cfce143f.jpeg";